import { render, staticRenderFns } from "./MoviesSeven.vue?vue&type=template&id=845cdf3c&scoped=true&"
import script from "./MoviesSeven.vue?vue&type=script&lang=js&"
export * from "./MoviesSeven.vue?vue&type=script&lang=js&"
import style0 from "./MoviesSeven.vue?vue&type=style&index=0&id=845cdf3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845cdf3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
